/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneAdTemplate as ResolvedStandaloneAdTemplate } from 'base/components/standalone/AdTemplate';

export const AdTemplate: typeof ResolvedStandaloneAdTemplate = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneAdTemplate {...props} />
        </ErrorBoundary>
    );
});

export type AdTemplateProps = PropsFromComponent<typeof AdTemplate>;

/** @deprecated Use slot architecture instead */
export const AdTemplateWith = (extras: DynamicStandaloneExtras): typeof AdTemplate => {
    return function AdTemplate(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AdTemplate');
        return <ResolvedStandaloneAdTemplate {...mergeProps({ options: { theme } }, props)} />;
    }
}